import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
 // BehaviorSubject with initial value
  private isClose = new BehaviorSubject<boolean>(false);
  updateClose = this.isClose.asObservable();


  
  constructor() { }

  // Change the message
  changeStatus(update: boolean) {
    this.isClose.next(update);
  }

}
